module.exports = __webpack_public_path__ + "img/escudo.04c62fc6.png";